import { AxiosResponse } from 'axios';
import cmsAPI from './knoxverse';
import { CMSSearchResult } from '../types/CMSSearchResult';

const fetchProgramSearchResults = async (terms: string, page: number): Promise<CMSSearchResult> => {
    const res: AxiosResponse<CMSSearchResult> = await cmsAPI.get(`/${KNOX_SEARCH_ID}.xml?tfrm=6&terms=${terms}&page=${page}&types=ProgramPage&ancestors=x6844`);

    const data = res.data;

    const items = data.SearchResults.Results?.Item;

    data.SearchResults.Results = {
        Item: Array.isArray(items) ? items : items ? [items] : []
    };

    return data;
};

export default fetchProgramSearchResults;